// eslint-disable-next-line import/prefer-default-export
export const BASE_CONFIG = {
  headers: {
    Accept: 'application/json;version=5',
  },
};
